import { Avatar, Grid, Paper, Typography } from "@mui/material"
import React, { FunctionComponent } from "react"
import { FormattedMessage } from "react-intl"
import Dimen from "../Dimen"

const reviews = [
  {
    name: "Alif Enterprise",
    avatar:
      "https://lh3.googleusercontent.com/a-/ALV-UjWEpulpJhTzNVG2HWbPI5AtHOX9WKOIM1KdPaXQLXITlw",
    text: "এই অ্যাপসটা আমি আলহামদুলিল্লাহ অনেক আগে থেকেই ইউজ করি.. থেকে আরেকটু আপডেট করা দরকার. জমা-খরচ আলাদা লিস্ট যোগ করা দরকার. ইন্টারফেস এবং আরো কিছু আপডেট করলে আরো খুশি হবে",
  },
  {
    name: "bhrc satkhira",
    avatar:
      "https://lh3.googleusercontent.com/a-/ALV-UjWdoIfWdQF15QEmNN7PU0jslHYV4J8TdJzth6JkAKbycQ",
    text: "Very Good",
  },
  {
    name: "Provita Feed Ltd",
    avatar:
      "https://lh3.googleusercontent.com/a-/ALV-UjU83SsKBJfW7MMfEEPa1mNLZLhgbrrwlKN-0yfgXTNHFw",
    text: "I am use this apps so help full apps.really Masha-Allah Md, belalHossain abid.comilla, Bangladesh",
  },
  {
    name: "সৌখিন টেলিভিশন",
    avatar:
      "https://lh3.googleusercontent.com/a-/ALV-UjUfy2ngzK3XDEI8ghIJzEZjip2SBLJWkAy8H6IMyLQDc84",
    text: "Nice App",
  },
]
const Reviews: FunctionComponent<{}> = () => {
  return (
    <React.Fragment>
      <Typography
        fontSize={Dimen.FontSizeHeading}
        align="center"
        color="text.primary"
        gutterBottom
        marginTop={Dimen.MarginDefault2x}
      >
        <FormattedMessage id="homepage.customer.feedback" />
      </Typography>

      {/* Youtube review */}
      <Grid container justifyContent={"center"}>
        <Grid>
          <iframe
            src="https://www.youtube.com/embed/C30rr6pSVms"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </Grid>
      </Grid>

      {/* Google Play reviews */}
      <Grid
        container
        spacing={2}
        direction={"row"}
        alignItems="center"
        padding={Dimen.PaddingDefault}
      >
        {reviews.map((review) => (
          <Grid size={{ xs: 12, sm: 12, md: 6, lg: 3 }}>
            <Paper
              elevation={9}
              style={{ padding: Dimen.PaddingDefault, height: "220px" }}
              square={false}
            >
              <Grid container alignItems={"center"}>
                <Avatar alt={review.name} src={review.avatar} />
                <h3 style={{ marginLeft: Dimen.MarginDefault }}>
                  {review.name}
                </h3>
              </Grid>
              {review.text}
            </Paper>
          </Grid>
        ))}
      </Grid>
    </React.Fragment>
  )
}

export default Reviews
